import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { ProtectedRouteProps } from '../interface/interface';
import { getUser, isAuthenticated } from '../services/service';
import { clearAuth } from '@/utils/authSession';
import { logHelper } from '@/utils';

const TAG = 'ProtectedRoute: ';
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {

  const location = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const user = getUser();

  logHelper(TAG, ' getUser() ', user);

  if (!user || !isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user.role === 'admin') {
    return <Navigate to="/admin" replace />;
  }

  if (user.role !== 'exhibitor') {
    clearAuth({ broadcast: false });
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute; 